import React, { useCallback, useEffect, useMemo, useState } from "react";
import { ExtendPermissionModal } from "../PermissionModal";
import UIFetchService from "../../Service/UIFetchService";
import {
  Row,
  Col,
  Table,
  Button,
  Tag,
  Space,
  Popconfirm,
  Tooltip,
  Input,
  Checkbox,
  Typography,
  Modal,
} from "antd";
import {
  EditOutlined,
  SettingOutlined,
  DeleteOutlined,
  CopyOutlined,
  FolderOpenOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { isNotEmpty } from "../../Service/Utils";
import useTableYScroll from "../../hooks/useTableYScroll";
import { SorterResult } from "antd/lib/table/interface";
import EditFolderModal, {
  useFolderEdit,
} from "../components/folder/EditFolderModal";
import MoveFolderModal from "./MoveFolderModal";
import {
  delDir,
  getDataSetRef,
  getFolderRef,
  moveDataSet,
  updateDir,
} from "./service";
import debounce from "lodash/debounce";

export default function TemplateListView() {
  const [templates, setTemplates] = useState<any[]>([]);
  const [searchKey, setSearchKey] = useState<string>("");
  const [permissionModaVisible, setPermissionModaVisible] = useState(false);
  const [incomingPermissionTmplId, setIncomingPermissionTmplId] =
    useState<number>(0);
  const [incomingPermissionLineLevel, setIncomingPermissionLineLevel] =
    useState<any>();
  const [ownsOnly, setOwnsOnly] = useState(false);
  const [sorter, setSorter] = useState<SorterResult<any> | SorterResult<any>[]>(
    {}
  );
  const [updateTime, setUpdateTime] = useState(new Date().getTime());
  const [folderEdit, setFolderEdit] = useFolderEdit();

  const addFolder = () => {
    setFolderEdit.setIsEdit(false);
    setFolderEdit.setVisible(true);
  };

  const editFolder = (id: number, name: string) => {
    setFolderEdit.setId(id);
    setFolderEdit.setName(name);
    setFolderEdit.setIsEdit(true);
    setFolderEdit.setVisible(true);
  };
  const [moveFolderVisible, setMoveFolderVisible] = useState(false);
  const [moveFolderTarget, setMoveFolderTarget] = useState(0);
  const y = useTableYScroll(250);
  const [expandedRowKeys, setExpandedRowKeys] = useState<number[]>([]);

  const columns = [
    {
      title: "名称",
      dataIndex: "name",
      key: "name",
      width: 280,
      sorter: true,
      render: (name, rd) => (
        <div
          style={{
            width: "calc(100% - 80px)",
            minWidth: "40px",
            display: "inline-block",
          }}
        >
          {rd.type === "folder" ? (
            <Typography.Text ellipsis>{name}</Typography.Text>
          ) : (
            <Tooltip title={rd.comments}>
              <Typography.Link
                href={`/standalone/templates/${rd.id}`}
                target="_blank"
                ellipsis
              >
                {name}
              </Typography.Link>
            </Tooltip>
          )}
        </div>
      ),
    },
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: 80,
      render: (text, record) => {
        if (record.type === "folder") {
          return "-";
        }
        return text;
      },
    },
    {
      title: "数据源",
      dataIndex: "syntax",
      key: "syntax",
      width: 280,
      render: (syntax, { projectName }) => {
        switch (syntax) {
          case "ODPS-SQL":
            return (
              <>
                <Tag color="#096dd9">Maxcompute</Tag>
                <span>{"/ "}</span>
                <Tag color="#a0d911">{projectName}</Tag>
              </>
            );
            break;
          case "HOLO-SQL":
            return (
              <>
                <Tag color="#fa8c16">Hologress</Tag>
                <span>{"/ "}</span>
                <Tag color="#a0d911">{projectName}</Tag>
              </>
            );
            break;
          default:
            return <>-</>;
            break;
        }
      },
    },
    {
      title: "创建时间",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: true,
      width: 200,
    },
    {
      title: "更新时间",
      dataIndex: "updatedAt",
      key: "updatedAt",
      sorter: true,
      width: 200,
    },
    {
      title: "创建人",
      dataIndex: "creatorName",
      key: "creatorName",
      sorter: true,
      width: 100,
    },
    {
      title: "操作",
      key: "operators",
      width: 130,
      fixed: "right",
      render: (_, rd) => {
        if (rd.type && rd.type === "folder") {
          return (
            <>
              <Space>
                <Tooltip title="编辑文件夹">
                  <Button
                    icon={<EditOutlined />}
                    size="small"
                    type="link"
                    onClick={() => {
                      editFolder(rd.id, rd.name);
                    }}
                  />
                </Tooltip>
                <Tooltip title="删除文件夹">
                  <Button
                    icon={<DeleteOutlined />}
                    danger
                    size="small"
                    type="link"
                    onClick={() =>
                      onDeleteFolder(rd.id, rd.children.length || 0)
                    }
                  />
                </Tooltip>
              </Space>
            </>
          );
        }
        return (
          <>
            {rd.action === "EDIT" && (
              <Space>
                <Tooltip title="编辑模版">
                  <Button
                    icon={<EditOutlined />}
                    size="small"
                    type="link"
                    href={`template/${rd.id}/detail`}
                  />
                </Tooltip>
                <Tooltip title="分配权限">
                  <Button
                    icon={<SettingOutlined />}
                    size="small"
                    type="link"
                    onClick={async () => {
                      const rs = await UIFetchService.get(
                        `/api/v1/querying_guide/templates/${rd.id}/can_be_line_level`
                      );
                      if (rs) {
                        setPermissionModaVisible(true);
                        setIncomingPermissionTmplId(rd.id);
                        setIncomingPermissionLineLevel(rs.result);
                      }
                    }}
                  />
                </Tooltip>
                <Tooltip title="移动数据集">
                  <Button
                    icon={<FolderOpenOutlined />}
                    size="small"
                    type="link"
                    onClick={() => {
                      setMoveFolderTarget(rd.id);
                      setMoveFolderVisible(true);
                    }}
                  />
                </Tooltip>
                <Popconfirm
                  title="是否复制此数据集?"
                  onConfirm={async () => {
                    await UIFetchService.post(
                      `/api/v1/querying_guide/templates/${rd.id}/clone`
                    );
                    setUpdateTime(new Date().getTime());
                  }}
                >
                  <Button icon={<CopyOutlined />} size="small" type="link" />
                </Popconfirm>

                <Button
                  icon={<DeleteOutlined />}
                  danger
                  size="small"
                  type="link"
                  onClick={() => onDeleteDataSet(rd.id)}
                />
              </Space>
            )}
          </>
        );
      },
    },
  ];

  const onDeleteFolder = async (folderId: string, childrenNum: number) => {
    try {
      // 查询是否有依赖
      let refs = await getFolderRef(parseInt(folderId));
      // 去重
      const exi = new Set();
      if (Array.isArray(refs) && refs.length > 0) {
        refs = refs.reduce((acc, cur) => {
          if (!exi.has(cur.referenceId)) {
            exi.add(cur.referenceId);
            return acc.concat([cur]);
          } else {
            return acc;
          }
        }, []);
      }
      Modal.confirm({
        title: (
          <>
            {childrenNum > 0 && (
              <>
                删除文件夹将会删除该文件中的{childrenNum}条资源
                <br />
              </>
            )}
            确定删除文件夹吗?
          </>
        ),
        icon: <ExclamationCircleOutlined />,
        content: (
          <>
            {Array.isArray(refs) && refs.length > 0 && (
              <div>
                <div>删除后会导致以下引用该数据集的对象失效</div>
                {refs.map((ref, index) => {
                  return (
                    <div key={index}>
                      {ref.type} : {ref.referenceName}
                    </div>
                  );
                })}
              </div>
            )}
          </>
        ),
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          try {
            delDir(parseInt(folderId));
          } catch (e) {
            console.error(e);
          } finally {
            setUpdateTime(new Date().getTime());
          }
        },
        onCancel() {
          console.log("取消");
        },
      });
    } catch (e) {
      console.error(e);
    }
  };

  const onDeleteDataSet = async (id: number) => {
    try {
      // 查询是否有依赖
      const refs = await getDataSetRef(id);
      Modal.confirm({
        title: <>确定要删除数据集吗?</>,
        icon: <ExclamationCircleOutlined />,
        content: (
          <>
            {Array.isArray(refs) && refs.length > 0 && (
              <div>
                <div>删除后会导致以下引用该数据集的对象失效</div>
                {refs.map((ref, index) => {
                  return (
                    <div key={index}>
                      {ref.type}：{ref.referenceName}
                    </div>
                  );
                })}
              </div>
            )}
          </>
        ),
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk: async () => {
          try {
            await UIFetchService.delete(
              `/api/v1/querying_guide/templates/${id}`
            );
          } catch (e) {
            console.error(e);
          } finally {
            setUpdateTime(new Date().getTime());
          }
        },
        onCancel() {
          console.log("取消");
        },
      });
    } catch (e) {
      console.error(e);
    }
  };

  const refreshTemplates = useCallback(async (params) => {
    if (params.searchKey === undefined) {
      params.searchKey = searchKey;
    }
    if (params.ownsOnly === undefined) {
      params.ownsOnly = ownsOnly;
    }
    const { sorter } = params;
    delete params.sorter;
    let query = `ownsOnly=${params.ownsOnly}`;
    if (isNotEmpty(params.searchKey)) {
      query = `${query}&key=${params.searchKey}`;
    }
    if (sorter !== undefined && Object.keys(sorter).length > 0) {
      delete sorter.column;
      query = `${query}&sorter=${encodeURI(JSON.stringify(sorter))}`;
    }
    const result = await UIFetchService.get(
      `/api/v1/querying_guide/templates?${query}`
    );
    if (params.searchKey && params.searchKey.length > 0) {
      setExpandedRowKeys(result.map((item) => item.directoryId));
    } else {
      setExpandedRowKeys([]);
    }

    setTemplates(
      result.map((item) => {
        return {
          id: item.directoryId,
          name: item.directoryName,
          children: item.templates,
          type: "folder",
          updatedAt: item.updatedAt,
          createdAt: item.createdAt,
          creatorName: item.creatorName,
        };
      })
    );
  }, []);
  const debounceRefreshTemplates = useCallback(
    debounce(refreshTemplates, 300),
    [refreshTemplates]
  );

  const getTemplateUsers = async (vid) => {
    const viewers = await UIFetchService.get(
      `/api/v1/querying_guide/templates/${vid}/perm_staffs?action=VIEW`
    );
    const editors = await UIFetchService.get(
      `/api/v1/querying_guide/templates/${vid}/perm_staffs?action=EDIT`
    );
    return { viewers, editors };
  };

  const setTemplateUsers = async (vid, viewers, editors) => {
    await UIFetchService.put(
      `/api/v1/querying_guide/templates/${vid}/perm_staffs?action=VIEW`,
      viewers
    );
    await UIFetchService.put(
      `/api/v1/querying_guide/templates/${vid}/perm_staffs?action=EDIT`,
      editors
    );
  };

  const getTemplateTeams = async (vid) => {
    return await UIFetchService.get(
      `/api/v1/querying_guide/templates/${vid}/perm_teams`
    );
  };

  const setTemplateTeams = async (vid, teams) => {
    await UIFetchService.put(
      `/api/v1/querying_guide/templates/${vid}/perm_teams`,
      teams
    );
  };

  useEffect(() => {
    debounceRefreshTemplates({
      ownsOnly,
      searchKey,
      sorter,
    });
  }, [searchKey, ownsOnly, sorter, updateTime]);

  const onExpand = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys(expandedRowKeys.concat([record.id]));
    } else {
      setExpandedRowKeys(expandedRowKeys.filter((key) => key != record.id));
    }
  };

  return (
    <>
      <Row style={{ margin: "12px 0 0 0" }}>
        <Col flex="300px" style={{ alignSelf: "center" }}>
          <Input.Search
            value={searchKey}
            onChange={({ target: { value } }) => {
              setSearchKey(value);
            }}
            placeholder="按名字、创建者搜索"
            style={{ width: "100%" }}
          />
        </Col>
        <Col style={{ alignSelf: "center", margin: "0 0 0 10px" }}>
          <Checkbox
            checked={ownsOnly}
            onChange={({ target: { checked } }) => {
              setOwnsOnly(checked);
            }}
          >
            只看自己
          </Checkbox>
        </Col>
        <Col flex="auto"></Col>
        <Col style={{ paddingRight: "30px" }}>
          <Button type="default" onClick={() => addFolder()}>
            新建文件夹
          </Button>
        </Col>
        <Col>
          <Button type="primary" href="/querying_guide/template/guide">
            新建数据集
          </Button>
        </Col>
      </Row>
      <div style={{ height: 10 }} />
      <Row>
        <Col flex="100%">
          <Table
            dataSource={templates}
            bordered
            size="small"
            style={{
              width: "100%",
            }}
            expandable={{
              defaultExpandAllRows: true,
              expandedRowKeys: expandedRowKeys,
              onExpand: onExpand,
            }}
            rowKey="id"
            scroll={{ x: 1000, y: y }}
            onChange={(pagination, filters, sorter) => {
              setSorter(sorter);
            }}
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            columns={columns}
          />
        </Col>
      </Row>
      {permissionModaVisible && (
        <ExtendPermissionModal
          visible={permissionModaVisible}
          lineLevel={incomingPermissionLineLevel}
          onCancel={() => setPermissionModaVisible(false)}
          title="模版权限管理"
          getUsers={async () =>
            await getTemplateUsers(incomingPermissionTmplId)
          }
          setUsers={async (viewers, editors) =>
            await setTemplateUsers(incomingPermissionTmplId, viewers, editors)
          }
          getTeams={async () =>
            await getTemplateTeams(incomingPermissionTmplId)
          }
          setTeams={async (teams) =>
            await setTemplateTeams(incomingPermissionTmplId, teams)
          }
        />
      )}
      {folderEdit.visible && (
        <EditFolderModal
          open={folderEdit.visible}
          isEdit={folderEdit.isEdit}
          id={folderEdit.id}
          name={folderEdit.name}
          onConfirm={async (params: {
            name: string;
            id?: number | undefined;
          }) => {
            setFolderEdit.setVisible(false);
            await updateDir(params);
            setUpdateTime(new Date().getTime());
          }}
          onCancel={function (): void {
            setFolderEdit.setVisible(false);
          }}
        />
      )}
      {moveFolderVisible && (
        <MoveFolderModal
          open={moveFolderVisible}
          onConfirm={async ({ folderId }) => {
            setMoveFolderVisible(false);
            await moveDataSet(moveFolderTarget, folderId);
            // 在此处移动
            setUpdateTime(new Date().getTime());
          }}
          onCancel={() => {
            setMoveFolderVisible(false);
          }}
        />
      )}
    </>
  );
}
